module.exports = __webpack_public_path__ + "static/media/send_icon.9b79e4d8.svg";